/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { StripeWebhookRequest } from "./StripeWebhookRequest";
export const StripeWebhook = core.serialization.object({
    id: core.serialization.string(),
    object: core.serialization.string(),
    data: core.serialization.record(core.serialization.string(), core.serialization.any()),
    request: StripeWebhookRequest,
    type: core.serialization.string(),
});
